import { render } from "./VisualEditsPanel.vue?vue&type=template&id=1d0a314e&scoped=true"
import script from "./VisualEditsPanel.vue?vue&type=script&lang=js"
export * from "./VisualEditsPanel.vue?vue&type=script&lang=js"

import "./VisualEditsPanel.vue?vue&type=style&index=0&id=1d0a314e&scoped=true&lang=css"
import "./VisualEditsPanel.vue?vue&type=style&index=1&id=1d0a314e&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1d0a314e"]])

export default __exports__